import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { OffersComponent } from "./offers/offers.component";
import { OfferDetailsComponent } from "./offer-details/offer-details.component";
import { OfferUpdateComponent } from "./offer-update/offer-update.component";


export const OFFER_ROUTES: Routes = [
  {
    path: 'offers',
    pathMatch: 'full',
    redirectTo: 'offers/overview'

  },
  {
    path: 'offers/overview',
    component: OffersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'offer/details/:prid/:offid',
    component: OfferDetailsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [authGuard]
  },
  {
    path: 'offer/update/:prid/:offid',
    component: OfferUpdateComponent,
    canActivate: [authGuard]
  }
]
